import { z } from 'zod';

import { useI18n } from '@change-corgi/core-react/i18n';

export function useFormSchema() {
	const { translate } = useI18n();

	return z.discriminatedUnion(
		'reach',
		[
			z.object({
				reach: z.literal('local'),
				locationId: z.string().min(1, { message: translate('corgi.start_a_petition.location.error.specify_location') }),
				locationName: z
					.string()
					.min(1, { message: translate('corgi.start_a_petition.location.error.specify_location') }),
			}),
			z.object({
				reach: z.enum(['national', 'global']),
				locationId: z.string().transform(() => null),
				locationName: z.string().transform(() => null),
			}),
		],
		{ error: () => translate('corgi.start_a_petition.location.error.select_scope') },
	);
}
